import { useTranslation } from "react-i18next";

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

import SourcesList from "./sources/SourcesList";

interface SourcesSheetProps {
  itemId: number;
  itemName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function SourcesSheet({
  itemId,
  itemName,
  open,
  onOpenChange,
}: SourcesSheetProps) {
  const { t } = useTranslation();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-2xl">
        <SheetHeader>
          <SheetTitle>{t("items.detail.sources.sheetTitle")}</SheetTitle>
          <SheetDescription>{itemName}</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-4 pb-4">
          <SourcesList itemId={itemId} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
